/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddFile as AgentApiContractAddFile } from '../models/AgentApi/Contract/add-file';
import { AddPaymentbycardResponse as AgentApiContractAddPaymentbycardResponse } from '../models/AgentApi/Contract/add-paymentbycard-response';
import { AddPtTicketResponse as AgentApiContractAddPtTicketResponse } from '../models/AgentApi/Contract/add-pt-ticket-response';
import { AddPurchaseResponse as AgentApiContractAddPurchaseResponse } from '../models/AgentApi/Contract/add-purchase-response';
import { AddShiftResponse as AgentApiContractAddShiftResponse } from '../models/AgentApi/Contract/add-shift-response';
import { Agent as AgentApiContractAgent } from '../models/AgentApi/Contract/agent';
import { AgentData as AgentApiContractAgentData } from '../models/AgentApi/Contract/agent-data';
import { AgentInfo as AgentApiContractAgentInfo } from '../models/AgentApi/Contract/agent-info';
import { AgentPayments as AgentApiContractAgentPayments } from '../models/AgentApi/Contract/agent-payments';
import { BalanceResponse as AgentApiContractBalanceResponse } from '../models/AgentApi/Contract/balance-response';
import { CancelPtTicketResponse as AgentApiContractCancelPtTicketResponse } from '../models/AgentApi/Contract/cancel-pt-ticket-response';
import { CardData as AgentApiContractCardData } from '../models/AgentApi/Contract/card-data';
import { ClientIdent as AgentApiContractClientIdent } from '../models/AgentApi/Contract/client-ident';
import { ClientIdentificationResponse as AgentApiContractClientIdentificationResponse } from '../models/AgentApi/Contract/client-identification-response';
import { FreecardData as AgentApiContractFreecardData } from '../models/AgentApi/Contract/freecard-data';
import { GetClientBalanceResponse as AgentApiContractGetClientBalanceResponse } from '../models/AgentApi/Contract/get-client-balance-response';
import { GetIdInfoResponse as AgentApiContractGetIdInfoResponse } from '../models/AgentApi/Contract/get-id-info-response';
import { GetPtTicketDataResponse as AgentApiContractGetPtTicketDataResponse } from '../models/AgentApi/Contract/get-pt-ticket-data-response';
import { GetShiftReportResponse as AgentApiContractGetShiftReportResponse } from '../models/AgentApi/Contract/get-shift-report-response';
import { IdtypeToadd as AgentApiContractIdtypeToadd } from '../models/AgentApi/Contract/idtype-toadd';
import { ListAvailTicketsResponse as AgentApiContractListAvailTicketsResponse } from '../models/AgentApi/Contract/list-avail-tickets-response';
import { ListIdtypeXResponse as AgentApiContractListIdtypeXResponse } from '../models/AgentApi/Contract/list-idtype-x-response';
import { ListPtTariffResponse as AgentApiContractListPtTariffResponse } from '../models/AgentApi/Contract/list-pt-tariff-response';
import { ListServiceTicketsResponse as AgentApiContractListServiceTicketsResponse } from '../models/AgentApi/Contract/list-service-tickets-response';
import { ListTicketTariffResponse as AgentApiContractListTicketTariffResponse } from '../models/AgentApi/Contract/list-ticket-tariff-response';
import { ListTrmOrgResponse as AgentApiContractListTrmOrgResponse } from '../models/AgentApi/Contract/list-trm-org-response';
import { LoadResultFile as AgentApiContractLoadResultFile } from '../models/AgentApi/Contract/load-result-file';
import { RegisterCardResponse as AgentApiContractRegisterCardResponse } from '../models/AgentApi/Contract/register-card-response';
import { SellCardResponse as AgentApiContractSellCardResponse } from '../models/AgentApi/Contract/sell-card-response';
import { SellerSettings as AgentApiContractSellerSettings } from '../models/AgentApi/Contract/seller-settings';
import { apiAgentAddAgentPaymentPost } from '../fn/agent/api-agent-add-agent-payment-post';
import { ApiAgentAddAgentPaymentPost$Params } from '../fn/agent/api-agent-add-agent-payment-post';
import { apiAgentAddAgentPost } from '../fn/agent/api-agent-add-agent-post';
import { ApiAgentAddAgentPost$Params } from '../fn/agent/api-agent-add-agent-post';
import { apiAgentAddAgentPost$Plain } from '../fn/agent/api-agent-add-agent-post-plain';
import { ApiAgentAddAgentPost$Plain$Params } from '../fn/agent/api-agent-add-agent-post-plain';
import { apiAgentAddPaymentbycardPost } from '../fn/agent/api-agent-add-paymentbycard-post';
import { ApiAgentAddPaymentbycardPost$Params } from '../fn/agent/api-agent-add-paymentbycard-post';
import { apiAgentAddPaymentbycardPost$Plain } from '../fn/agent/api-agent-add-paymentbycard-post-plain';
import { ApiAgentAddPaymentbycardPost$Plain$Params } from '../fn/agent/api-agent-add-paymentbycard-post-plain';
import { apiAgentAddPaymentbytokenPost } from '../fn/agent/api-agent-add-paymentbytoken-post';
import { ApiAgentAddPaymentbytokenPost$Params } from '../fn/agent/api-agent-add-paymentbytoken-post';
import { apiAgentAddPtTicketPost } from '../fn/agent/api-agent-add-pt-ticket-post';
import { ApiAgentAddPtTicketPost$Params } from '../fn/agent/api-agent-add-pt-ticket-post';
import { apiAgentAddPtTicketPost$Plain } from '../fn/agent/api-agent-add-pt-ticket-post-plain';
import { ApiAgentAddPtTicketPost$Plain$Params } from '../fn/agent/api-agent-add-pt-ticket-post-plain';
import { apiAgentAddPurchasePost } from '../fn/agent/api-agent-add-purchase-post';
import { ApiAgentAddPurchasePost$Params } from '../fn/agent/api-agent-add-purchase-post';
import { apiAgentAddPurchasePost$Plain } from '../fn/agent/api-agent-add-purchase-post-plain';
import { ApiAgentAddPurchasePost$Plain$Params } from '../fn/agent/api-agent-add-purchase-post-plain';
import { apiAgentAddShiftPost } from '../fn/agent/api-agent-add-shift-post';
import { ApiAgentAddShiftPost$Params } from '../fn/agent/api-agent-add-shift-post';
import { apiAgentAddShiftPost$Plain } from '../fn/agent/api-agent-add-shift-post-plain';
import { ApiAgentAddShiftPost$Plain$Params } from '../fn/agent/api-agent-add-shift-post-plain';
import { apiAgentCancelPtTicketPost } from '../fn/agent/api-agent-cancel-pt-ticket-post';
import { ApiAgentCancelPtTicketPost$Params } from '../fn/agent/api-agent-cancel-pt-ticket-post';
import { apiAgentCancelPtTicketPost$Plain } from '../fn/agent/api-agent-cancel-pt-ticket-post-plain';
import { ApiAgentCancelPtTicketPost$Plain$Params } from '../fn/agent/api-agent-cancel-pt-ticket-post-plain';
import { apiAgentCheckIdIsdoublePost } from '../fn/agent/api-agent-check-id-isdouble-post';
import { ApiAgentCheckIdIsdoublePost$Params } from '../fn/agent/api-agent-check-id-isdouble-post';
import { apiAgentClientIdentificationPost } from '../fn/agent/api-agent-client-identification-post';
import { ApiAgentClientIdentificationPost$Params } from '../fn/agent/api-agent-client-identification-post';
import { apiAgentClientIdentificationPost$Plain } from '../fn/agent/api-agent-client-identification-post-plain';
import { ApiAgentClientIdentificationPost$Plain$Params } from '../fn/agent/api-agent-client-identification-post-plain';
import { apiAgentGetAgentDataGet } from '../fn/agent/api-agent-get-agent-data-get';
import { ApiAgentGetAgentDataGet$Params } from '../fn/agent/api-agent-get-agent-data-get';
import { apiAgentGetAgentDataGet$Plain } from '../fn/agent/api-agent-get-agent-data-get-plain';
import { ApiAgentGetAgentDataGet$Plain$Params } from '../fn/agent/api-agent-get-agent-data-get-plain';
import { apiAgentGetBalanceGet } from '../fn/agent/api-agent-get-balance-get';
import { ApiAgentGetBalanceGet$Params } from '../fn/agent/api-agent-get-balance-get';
import { apiAgentGetBalanceGet$Plain } from '../fn/agent/api-agent-get-balance-get-plain';
import { ApiAgentGetBalanceGet$Plain$Params } from '../fn/agent/api-agent-get-balance-get-plain';
import { apiAgentGetCardDataPost } from '../fn/agent/api-agent-get-card-data-post';
import { ApiAgentGetCardDataPost$Params } from '../fn/agent/api-agent-get-card-data-post';
import { apiAgentGetCardDataPost$Plain } from '../fn/agent/api-agent-get-card-data-post-plain';
import { ApiAgentGetCardDataPost$Plain$Params } from '../fn/agent/api-agent-get-card-data-post-plain';
import { apiAgentGetClientBalancePost } from '../fn/agent/api-agent-get-client-balance-post';
import { ApiAgentGetClientBalancePost$Params } from '../fn/agent/api-agent-get-client-balance-post';
import { apiAgentGetClientBalancePost$Plain } from '../fn/agent/api-agent-get-client-balance-post-plain';
import { ApiAgentGetClientBalancePost$Plain$Params } from '../fn/agent/api-agent-get-client-balance-post-plain';
import { apiAgentGetClientIdentPost } from '../fn/agent/api-agent-get-client-ident-post';
import { ApiAgentGetClientIdentPost$Params } from '../fn/agent/api-agent-get-client-ident-post';
import { apiAgentGetClientIdentPost$Plain } from '../fn/agent/api-agent-get-client-ident-post-plain';
import { ApiAgentGetClientIdentPost$Plain$Params } from '../fn/agent/api-agent-get-client-ident-post-plain';
import { apiAgentGetFreecardDataPost } from '../fn/agent/api-agent-get-freecard-data-post';
import { ApiAgentGetFreecardDataPost$Params } from '../fn/agent/api-agent-get-freecard-data-post';
import { apiAgentGetFreecardDataPost$Plain } from '../fn/agent/api-agent-get-freecard-data-post-plain';
import { ApiAgentGetFreecardDataPost$Plain$Params } from '../fn/agent/api-agent-get-freecard-data-post-plain';
import { apiAgentGetIdInfoPost } from '../fn/agent/api-agent-get-id-info-post';
import { ApiAgentGetIdInfoPost$Params } from '../fn/agent/api-agent-get-id-info-post';
import { apiAgentGetIdInfoPost$Plain } from '../fn/agent/api-agent-get-id-info-post-plain';
import { ApiAgentGetIdInfoPost$Plain$Params } from '../fn/agent/api-agent-get-id-info-post-plain';
import { apiAgentGetPtTicketDataGet } from '../fn/agent/api-agent-get-pt-ticket-data-get';
import { ApiAgentGetPtTicketDataGet$Params } from '../fn/agent/api-agent-get-pt-ticket-data-get';
import { apiAgentGetPtTicketDataGet$Plain } from '../fn/agent/api-agent-get-pt-ticket-data-get-plain';
import { ApiAgentGetPtTicketDataGet$Plain$Params } from '../fn/agent/api-agent-get-pt-ticket-data-get-plain';
import { apiAgentGetSellerSettingsGet } from '../fn/agent/api-agent-get-seller-settings-get';
import { ApiAgentGetSellerSettingsGet$Params } from '../fn/agent/api-agent-get-seller-settings-get';
import { apiAgentGetSellerSettingsGet$Plain } from '../fn/agent/api-agent-get-seller-settings-get-plain';
import { ApiAgentGetSellerSettingsGet$Plain$Params } from '../fn/agent/api-agent-get-seller-settings-get-plain';
import { apiAgentGetShiftReportPost } from '../fn/agent/api-agent-get-shift-report-post';
import { ApiAgentGetShiftReportPost$Params } from '../fn/agent/api-agent-get-shift-report-post';
import { apiAgentGetShiftReportPost$Plain } from '../fn/agent/api-agent-get-shift-report-post-plain';
import { ApiAgentGetShiftReportPost$Plain$Params } from '../fn/agent/api-agent-get-shift-report-post-plain';
import { apiAgentListAgentGet } from '../fn/agent/api-agent-list-agent-get';
import { ApiAgentListAgentGet$Params } from '../fn/agent/api-agent-list-agent-get';
import { apiAgentListAgentGet$Plain } from '../fn/agent/api-agent-list-agent-get-plain';
import { ApiAgentListAgentGet$Plain$Params } from '../fn/agent/api-agent-list-agent-get-plain';
import { apiAgentListAgentPaymentsGet } from '../fn/agent/api-agent-list-agent-payments-get';
import { ApiAgentListAgentPaymentsGet$Params } from '../fn/agent/api-agent-list-agent-payments-get';
import { apiAgentListAgentPaymentsGet$Plain } from '../fn/agent/api-agent-list-agent-payments-get-plain';
import { ApiAgentListAgentPaymentsGet$Plain$Params } from '../fn/agent/api-agent-list-agent-payments-get-plain';
import { apiAgentListAvailTicketsPost } from '../fn/agent/api-agent-list-avail-tickets-post';
import { ApiAgentListAvailTicketsPost$Params } from '../fn/agent/api-agent-list-avail-tickets-post';
import { apiAgentListAvailTicketsPost$Plain } from '../fn/agent/api-agent-list-avail-tickets-post-plain';
import { ApiAgentListAvailTicketsPost$Plain$Params } from '../fn/agent/api-agent-list-avail-tickets-post-plain';
import { apiAgentListIdtypeToaddGet } from '../fn/agent/api-agent-list-idtype-toadd-get';
import { ApiAgentListIdtypeToaddGet$Params } from '../fn/agent/api-agent-list-idtype-toadd-get';
import { apiAgentListIdtypeToaddGet$Plain } from '../fn/agent/api-agent-list-idtype-toadd-get-plain';
import { ApiAgentListIdtypeToaddGet$Plain$Params } from '../fn/agent/api-agent-list-idtype-toadd-get-plain';
import { apiAgentListIdtypeXGet } from '../fn/agent/api-agent-list-idtype-x-get';
import { ApiAgentListIdtypeXGet$Params } from '../fn/agent/api-agent-list-idtype-x-get';
import { apiAgentListIdtypeXGet$Plain } from '../fn/agent/api-agent-list-idtype-x-get-plain';
import { ApiAgentListIdtypeXGet$Plain$Params } from '../fn/agent/api-agent-list-idtype-x-get-plain';
import { apiAgentListLoadResultGet } from '../fn/agent/api-agent-list-load-result-get';
import { ApiAgentListLoadResultGet$Params } from '../fn/agent/api-agent-list-load-result-get';
import { apiAgentListLoadResultGet$Plain } from '../fn/agent/api-agent-list-load-result-get-plain';
import { ApiAgentListLoadResultGet$Plain$Params } from '../fn/agent/api-agent-list-load-result-get-plain';
import { apiAgentListPtTariffGet } from '../fn/agent/api-agent-list-pt-tariff-get';
import { ApiAgentListPtTariffGet$Params } from '../fn/agent/api-agent-list-pt-tariff-get';
import { apiAgentListPtTariffGet$Plain } from '../fn/agent/api-agent-list-pt-tariff-get-plain';
import { ApiAgentListPtTariffGet$Plain$Params } from '../fn/agent/api-agent-list-pt-tariff-get-plain';
import { apiAgentListServiceTicketsPost } from '../fn/agent/api-agent-list-service-tickets-post';
import { ApiAgentListServiceTicketsPost$Params } from '../fn/agent/api-agent-list-service-tickets-post';
import { apiAgentListServiceTicketsPost$Plain } from '../fn/agent/api-agent-list-service-tickets-post-plain';
import { ApiAgentListServiceTicketsPost$Plain$Params } from '../fn/agent/api-agent-list-service-tickets-post-plain';
import { apiAgentListTicketTariffGet } from '../fn/agent/api-agent-list-ticket-tariff-get';
import { ApiAgentListTicketTariffGet$Params } from '../fn/agent/api-agent-list-ticket-tariff-get';
import { apiAgentListTicketTariffGet$Plain } from '../fn/agent/api-agent-list-ticket-tariff-get-plain';
import { ApiAgentListTicketTariffGet$Plain$Params } from '../fn/agent/api-agent-list-ticket-tariff-get-plain';
import { apiAgentListTrmOrgGet } from '../fn/agent/api-agent-list-trm-org-get';
import { ApiAgentListTrmOrgGet$Params } from '../fn/agent/api-agent-list-trm-org-get';
import { apiAgentListTrmOrgGet$Plain } from '../fn/agent/api-agent-list-trm-org-get-plain';
import { ApiAgentListTrmOrgGet$Plain$Params } from '../fn/agent/api-agent-list-trm-org-get-plain';
import { apiAgentLoadCardFilePost } from '../fn/agent/api-agent-load-card-file-post';
import { ApiAgentLoadCardFilePost$Params } from '../fn/agent/api-agent-load-card-file-post';
import { apiAgentLoadCardFilePost$Plain } from '../fn/agent/api-agent-load-card-file-post-plain';
import { ApiAgentLoadCardFilePost$Plain$Params } from '../fn/agent/api-agent-load-card-file-post-plain';
import { apiAgentRegisterCardPost } from '../fn/agent/api-agent-register-card-post';
import { ApiAgentRegisterCardPost$Params } from '../fn/agent/api-agent-register-card-post';
import { apiAgentRegisterCardPost$Plain } from '../fn/agent/api-agent-register-card-post-plain';
import { ApiAgentRegisterCardPost$Plain$Params } from '../fn/agent/api-agent-register-card-post-plain';
import { apiAgentRegisterCardSmsConfirmPost } from '../fn/agent/api-agent-register-card-sms-confirm-post';
import { ApiAgentRegisterCardSmsConfirmPost$Params } from '../fn/agent/api-agent-register-card-sms-confirm-post';
import { apiAgentRegisterCardSmsConfirmPost$Plain } from '../fn/agent/api-agent-register-card-sms-confirm-post-plain';
import { ApiAgentRegisterCardSmsConfirmPost$Plain$Params } from '../fn/agent/api-agent-register-card-sms-confirm-post-plain';
import { apiAgentRegisterCardSmsPost } from '../fn/agent/api-agent-register-card-sms-post';
import { ApiAgentRegisterCardSmsPost$Params } from '../fn/agent/api-agent-register-card-sms-post';
import { apiAgentRemoveAgentDelete } from '../fn/agent/api-agent-remove-agent-delete';
import { ApiAgentRemoveAgentDelete$Params } from '../fn/agent/api-agent-remove-agent-delete';
import { apiAgentSellCardPost } from '../fn/agent/api-agent-sell-card-post';
import { ApiAgentSellCardPost$Params } from '../fn/agent/api-agent-sell-card-post';
import { apiAgentSellCardPost$Plain } from '../fn/agent/api-agent-sell-card-post-plain';
import { ApiAgentSellCardPost$Plain$Params } from '../fn/agent/api-agent-sell-card-post-plain';
import { apiAgentSetAgentPaymentStatusPost } from '../fn/agent/api-agent-set-agent-payment-status-post';
import { ApiAgentSetAgentPaymentStatusPost$Params } from '../fn/agent/api-agent-set-agent-payment-status-post';
import { apiAgentSetAgentPost } from '../fn/agent/api-agent-set-agent-post';
import { ApiAgentSetAgentPost$Params } from '../fn/agent/api-agent-set-agent-post';
import { apiAgentSetShiftClosePost } from '../fn/agent/api-agent-set-shift-close-post';
import { ApiAgentSetShiftClosePost$Params } from '../fn/agent/api-agent-set-shift-close-post';

@Injectable({ providedIn: 'root' })
export class AgentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAgentGetFreecardDataPost()` */
  static readonly ApiAgentGetFreecardDataPostPath = '/api/Agent/GetFreecardData';

  /**
   * view map data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetFreecardDataPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetFreecardDataPost$Plain$Response(params?: ApiAgentGetFreecardDataPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractFreecardData>> {
    return apiAgentGetFreecardDataPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * view map data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetFreecardDataPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetFreecardDataPost$Plain(params?: ApiAgentGetFreecardDataPost$Plain$Params, context?: HttpContext): Observable<AgentApiContractFreecardData> {
    return this.apiAgentGetFreecardDataPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractFreecardData>): AgentApiContractFreecardData => r.body)
    );
  }

  /**
   * view map data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetFreecardDataPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetFreecardDataPost$Response(params?: ApiAgentGetFreecardDataPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractFreecardData>> {
    return apiAgentGetFreecardDataPost(this.http, this.rootUrl, params, context);
  }

  /**
   * view map data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetFreecardDataPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetFreecardDataPost(params?: ApiAgentGetFreecardDataPost$Params, context?: HttpContext): Observable<AgentApiContractFreecardData> {
    return this.apiAgentGetFreecardDataPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractFreecardData>): AgentApiContractFreecardData => r.body)
    );
  }

  /** Path part for operation `apiAgentSellCardPost()` */
  static readonly ApiAgentSellCardPostPath = '/api/Agent/SellCard';

  /**
   * Sale of the card (only from the warehouse of the agent).
   *
   * uid = 0x41 + uid + sak
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentSellCardPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentSellCardPost$Plain$Response(params?: ApiAgentSellCardPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractSellCardResponse>> {
    return apiAgentSellCardPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Sale of the card (only from the warehouse of the agent).
   *
   * uid = 0x41 + uid + sak
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentSellCardPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentSellCardPost$Plain(params?: ApiAgentSellCardPost$Plain$Params, context?: HttpContext): Observable<AgentApiContractSellCardResponse> {
    return this.apiAgentSellCardPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractSellCardResponse>): AgentApiContractSellCardResponse => r.body)
    );
  }

  /**
   * Sale of the card (only from the warehouse of the agent).
   *
   * uid = 0x41 + uid + sak
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentSellCardPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentSellCardPost$Response(params?: ApiAgentSellCardPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractSellCardResponse>> {
    return apiAgentSellCardPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Sale of the card (only from the warehouse of the agent).
   *
   * uid = 0x41 + uid + sak
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentSellCardPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentSellCardPost(params?: ApiAgentSellCardPost$Params, context?: HttpContext): Observable<AgentApiContractSellCardResponse> {
    return this.apiAgentSellCardPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractSellCardResponse>): AgentApiContractSellCardResponse => r.body)
    );
  }

  /** Path part for operation `apiAgentRegisterCardPost()` */
  static readonly ApiAgentRegisterCardPostPath = '/api/Agent/RegisterCard';

  /**
   * Card registration (should not be in any of the warehouses).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentRegisterCardPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentRegisterCardPost$Plain$Response(params?: ApiAgentRegisterCardPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractRegisterCardResponse>> {
    return apiAgentRegisterCardPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Card registration (should not be in any of the warehouses).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentRegisterCardPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentRegisterCardPost$Plain(params?: ApiAgentRegisterCardPost$Plain$Params, context?: HttpContext): Observable<AgentApiContractRegisterCardResponse> {
    return this.apiAgentRegisterCardPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractRegisterCardResponse>): AgentApiContractRegisterCardResponse => r.body)
    );
  }

  /**
   * Card registration (should not be in any of the warehouses).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentRegisterCardPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentRegisterCardPost$Response(params?: ApiAgentRegisterCardPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractRegisterCardResponse>> {
    return apiAgentRegisterCardPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Card registration (should not be in any of the warehouses).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentRegisterCardPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentRegisterCardPost(params?: ApiAgentRegisterCardPost$Params, context?: HttpContext): Observable<AgentApiContractRegisterCardResponse> {
    return this.apiAgentRegisterCardPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractRegisterCardResponse>): AgentApiContractRegisterCardResponse => r.body)
    );
  }

  /** Path part for operation `apiAgentRegisterCardSmsPost()` */
  static readonly ApiAgentRegisterCardSmsPostPath = '/api/Agent/RegisterCardSMS';

  /**
   * Card registration request with confirmation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentRegisterCardSmsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentRegisterCardSmsPost$Response(params?: ApiAgentRegisterCardSmsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgentRegisterCardSmsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Card registration request with confirmation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentRegisterCardSmsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentRegisterCardSmsPost(params?: ApiAgentRegisterCardSmsPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAgentRegisterCardSmsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgentRegisterCardSmsConfirmPost()` */
  static readonly ApiAgentRegisterCardSmsConfirmPostPath = '/api/Agent/RegisterCardSMSConfirm';

  /**
   * Card registration confirmation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentRegisterCardSmsConfirmPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentRegisterCardSmsConfirmPost$Plain$Response(params?: ApiAgentRegisterCardSmsConfirmPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractRegisterCardResponse>> {
    return apiAgentRegisterCardSmsConfirmPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Card registration confirmation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentRegisterCardSmsConfirmPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentRegisterCardSmsConfirmPost$Plain(params?: ApiAgentRegisterCardSmsConfirmPost$Plain$Params, context?: HttpContext): Observable<AgentApiContractRegisterCardResponse> {
    return this.apiAgentRegisterCardSmsConfirmPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractRegisterCardResponse>): AgentApiContractRegisterCardResponse => r.body)
    );
  }

  /**
   * Card registration confirmation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentRegisterCardSmsConfirmPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentRegisterCardSmsConfirmPost$Response(params?: ApiAgentRegisterCardSmsConfirmPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractRegisterCardResponse>> {
    return apiAgentRegisterCardSmsConfirmPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Card registration confirmation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentRegisterCardSmsConfirmPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentRegisterCardSmsConfirmPost(params?: ApiAgentRegisterCardSmsConfirmPost$Params, context?: HttpContext): Observable<AgentApiContractRegisterCardResponse> {
    return this.apiAgentRegisterCardSmsConfirmPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractRegisterCardResponse>): AgentApiContractRegisterCardResponse => r.body)
    );
  }

  /** Path part for operation `apiAgentAddPaymentbycardPost()` */
  static readonly ApiAgentAddPaymentbycardPostPath = '/api/Agent/AddPaymentbycard';

  /**
   * Replenishment of the client's account by card.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentAddPaymentbycardPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddPaymentbycardPost$Plain$Response(params?: ApiAgentAddPaymentbycardPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAddPaymentbycardResponse>> {
    return apiAgentAddPaymentbycardPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Replenishment of the client's account by card.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentAddPaymentbycardPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddPaymentbycardPost$Plain(params?: ApiAgentAddPaymentbycardPost$Plain$Params, context?: HttpContext): Observable<AgentApiContractAddPaymentbycardResponse> {
    return this.apiAgentAddPaymentbycardPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractAddPaymentbycardResponse>): AgentApiContractAddPaymentbycardResponse => r.body)
    );
  }

  /**
   * Replenishment of the client's account by card.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentAddPaymentbycardPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddPaymentbycardPost$Response(params?: ApiAgentAddPaymentbycardPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAddPaymentbycardResponse>> {
    return apiAgentAddPaymentbycardPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Replenishment of the client's account by card.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentAddPaymentbycardPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddPaymentbycardPost(params?: ApiAgentAddPaymentbycardPost$Params, context?: HttpContext): Observable<AgentApiContractAddPaymentbycardResponse> {
    return this.apiAgentAddPaymentbycardPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractAddPaymentbycardResponse>): AgentApiContractAddPaymentbycardResponse => r.body)
    );
  }

  /** Path part for operation `apiAgentGetCardDataPost()` */
  static readonly ApiAgentGetCardDataPostPath = '/api/Agent/GetCardData';

  /**
   * receipt of a printed card number when replenishing by UID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetCardDataPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetCardDataPost$Plain$Response(params?: ApiAgentGetCardDataPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractCardData>> {
    return apiAgentGetCardDataPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * receipt of a printed card number when replenishing by UID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetCardDataPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetCardDataPost$Plain(params?: ApiAgentGetCardDataPost$Plain$Params, context?: HttpContext): Observable<AgentApiContractCardData> {
    return this.apiAgentGetCardDataPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractCardData>): AgentApiContractCardData => r.body)
    );
  }

  /**
   * receipt of a printed card number when replenishing by UID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetCardDataPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetCardDataPost$Response(params?: ApiAgentGetCardDataPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractCardData>> {
    return apiAgentGetCardDataPost(this.http, this.rootUrl, params, context);
  }

  /**
   * receipt of a printed card number when replenishing by UID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetCardDataPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetCardDataPost(params?: ApiAgentGetCardDataPost$Params, context?: HttpContext): Observable<AgentApiContractCardData> {
    return this.apiAgentGetCardDataPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractCardData>): AgentApiContractCardData => r.body)
    );
  }

  /** Path part for operation `apiAgentAddPaymentbytokenPost()` */
  static readonly ApiAgentAddPaymentbytokenPostPath = '/api/Agent/AddPaymentbytoken';

  /**
   * replenishment of the balance by bar code.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentAddPaymentbytokenPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddPaymentbytokenPost$Response(params?: ApiAgentAddPaymentbytokenPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgentAddPaymentbytokenPost(this.http, this.rootUrl, params, context);
  }

  /**
   * replenishment of the balance by bar code.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentAddPaymentbytokenPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddPaymentbytokenPost(params?: ApiAgentAddPaymentbytokenPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAgentAddPaymentbytokenPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgentGetBalanceGet()` */
  static readonly ApiAgentGetBalanceGetPath = '/api/Agent/GetBalance';

  /**
   * Agent balance request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetBalanceGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetBalanceGet$Plain$Response(params?: ApiAgentGetBalanceGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractBalanceResponse>> {
    return apiAgentGetBalanceGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Agent balance request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetBalanceGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetBalanceGet$Plain(params?: ApiAgentGetBalanceGet$Plain$Params, context?: HttpContext): Observable<AgentApiContractBalanceResponse> {
    return this.apiAgentGetBalanceGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractBalanceResponse>): AgentApiContractBalanceResponse => r.body)
    );
  }

  /**
   * Agent balance request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetBalanceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetBalanceGet$Response(params?: ApiAgentGetBalanceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractBalanceResponse>> {
    return apiAgentGetBalanceGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Agent balance request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetBalanceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetBalanceGet(params?: ApiAgentGetBalanceGet$Params, context?: HttpContext): Observable<AgentApiContractBalanceResponse> {
    return this.apiAgentGetBalanceGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractBalanceResponse>): AgentApiContractBalanceResponse => r.body)
    );
  }

  /** Path part for operation `apiAgentAddAgentPaymentPost()` */
  static readonly ApiAgentAddAgentPaymentPostPath = '/api/Agent/AddAgentPayment';

  /**
   * Creating a request for replenishment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentAddAgentPaymentPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddAgentPaymentPost$Response(params?: ApiAgentAddAgentPaymentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgentAddAgentPaymentPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creating a request for replenishment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentAddAgentPaymentPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddAgentPaymentPost(params?: ApiAgentAddAgentPaymentPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAgentAddAgentPaymentPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgentSetAgentPaymentStatusPost()` */
  static readonly ApiAgentSetAgentPaymentStatusPostPath = '/api/Agent/SetAgentPaymentStatus';

  /**
   * Replenishment confirmation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentSetAgentPaymentStatusPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentSetAgentPaymentStatusPost$Response(params?: ApiAgentSetAgentPaymentStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgentSetAgentPaymentStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Replenishment confirmation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentSetAgentPaymentStatusPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentSetAgentPaymentStatusPost(params?: ApiAgentSetAgentPaymentStatusPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAgentSetAgentPaymentStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgentListAgentPaymentsGet()` */
  static readonly ApiAgentListAgentPaymentsGetPath = '/api/Agent/ListAgentPayments';

  /**
   * Getting a list of replenishment operations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListAgentPaymentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListAgentPaymentsGet$Plain$Response(params?: ApiAgentListAgentPaymentsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractAgentPayments>>> {
    return apiAgentListAgentPaymentsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of replenishment operations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListAgentPaymentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListAgentPaymentsGet$Plain(params?: ApiAgentListAgentPaymentsGet$Plain$Params, context?: HttpContext): Observable<Array<AgentApiContractAgentPayments>> {
    return this.apiAgentListAgentPaymentsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractAgentPayments>>): Array<AgentApiContractAgentPayments> => r.body)
    );
  }

  /**
   * Getting a list of replenishment operations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListAgentPaymentsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListAgentPaymentsGet$Response(params?: ApiAgentListAgentPaymentsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractAgentPayments>>> {
    return apiAgentListAgentPaymentsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of replenishment operations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListAgentPaymentsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListAgentPaymentsGet(params?: ApiAgentListAgentPaymentsGet$Params, context?: HttpContext): Observable<Array<AgentApiContractAgentPayments>> {
    return this.apiAgentListAgentPaymentsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractAgentPayments>>): Array<AgentApiContractAgentPayments> => r.body)
    );
  }

  /** Path part for operation `apiAgentGetSellerSettingsGet()` */
  static readonly ApiAgentGetSellerSettingsGetPath = '/api/Agent/GetSellerSettings';

  /**
   * Getting agent settings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetSellerSettingsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetSellerSettingsGet$Plain$Response(params?: ApiAgentGetSellerSettingsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractSellerSettings>> {
    return apiAgentGetSellerSettingsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting agent settings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetSellerSettingsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetSellerSettingsGet$Plain(params?: ApiAgentGetSellerSettingsGet$Plain$Params, context?: HttpContext): Observable<AgentApiContractSellerSettings> {
    return this.apiAgentGetSellerSettingsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractSellerSettings>): AgentApiContractSellerSettings => r.body)
    );
  }

  /**
   * Getting agent settings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetSellerSettingsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetSellerSettingsGet$Response(params?: ApiAgentGetSellerSettingsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractSellerSettings>> {
    return apiAgentGetSellerSettingsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting agent settings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetSellerSettingsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetSellerSettingsGet(params?: ApiAgentGetSellerSettingsGet$Params, context?: HttpContext): Observable<AgentApiContractSellerSettings> {
    return this.apiAgentGetSellerSettingsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractSellerSettings>): AgentApiContractSellerSettings => r.body)
    );
  }

  /** Path part for operation `apiAgentLoadCardFilePost()` */
  static readonly ApiAgentLoadCardFilePostPath = '/api/Agent/LoadCardFile';

  /**
   * Upload "stock cards".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentLoadCardFilePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentLoadCardFilePost$Plain$Response(params?: ApiAgentLoadCardFilePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAddFile>> {
    return apiAgentLoadCardFilePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload "stock cards".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentLoadCardFilePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentLoadCardFilePost$Plain(params?: ApiAgentLoadCardFilePost$Plain$Params, context?: HttpContext): Observable<AgentApiContractAddFile> {
    return this.apiAgentLoadCardFilePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractAddFile>): AgentApiContractAddFile => r.body)
    );
  }

  /**
   * Upload "stock cards".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentLoadCardFilePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentLoadCardFilePost$Response(params?: ApiAgentLoadCardFilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAddFile>> {
    return apiAgentLoadCardFilePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload "stock cards".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentLoadCardFilePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentLoadCardFilePost(params?: ApiAgentLoadCardFilePost$Params, context?: HttpContext): Observable<AgentApiContractAddFile> {
    return this.apiAgentLoadCardFilePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractAddFile>): AgentApiContractAddFile => r.body)
    );
  }

  /** Path part for operation `apiAgentListLoadResultGet()` */
  static readonly ApiAgentListLoadResultGetPath = '/api/Agent/ListLoadResult';

  /**
   * Getting the download result.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListLoadResultGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListLoadResultGet$Plain$Response(params?: ApiAgentListLoadResultGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractLoadResultFile>> {
    return apiAgentListLoadResultGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the download result.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListLoadResultGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListLoadResultGet$Plain(params?: ApiAgentListLoadResultGet$Plain$Params, context?: HttpContext): Observable<AgentApiContractLoadResultFile> {
    return this.apiAgentListLoadResultGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractLoadResultFile>): AgentApiContractLoadResultFile => r.body)
    );
  }

  /**
   * Getting the download result.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListLoadResultGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListLoadResultGet$Response(params?: ApiAgentListLoadResultGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractLoadResultFile>> {
    return apiAgentListLoadResultGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the download result.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListLoadResultGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListLoadResultGet(params?: ApiAgentListLoadResultGet$Params, context?: HttpContext): Observable<AgentApiContractLoadResultFile> {
    return this.apiAgentListLoadResultGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractLoadResultFile>): AgentApiContractLoadResultFile => r.body)
    );
  }

  /** Path part for operation `apiAgentAddAgentPost()` */
  static readonly ApiAgentAddAgentPostPath = '/api/Agent/AddAgent';

  /**
   * Adding an agent.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentAddAgentPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddAgentPost$Plain$Response(params?: ApiAgentAddAgentPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAgent>> {
    return apiAgentAddAgentPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Adding an agent.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentAddAgentPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddAgentPost$Plain(params?: ApiAgentAddAgentPost$Plain$Params, context?: HttpContext): Observable<AgentApiContractAgent> {
    return this.apiAgentAddAgentPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractAgent>): AgentApiContractAgent => r.body)
    );
  }

  /**
   * Adding an agent.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentAddAgentPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddAgentPost$Response(params?: ApiAgentAddAgentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAgent>> {
    return apiAgentAddAgentPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Adding an agent.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentAddAgentPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddAgentPost(params?: ApiAgentAddAgentPost$Params, context?: HttpContext): Observable<AgentApiContractAgent> {
    return this.apiAgentAddAgentPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractAgent>): AgentApiContractAgent => r.body)
    );
  }

  /** Path part for operation `apiAgentRemoveAgentDelete()` */
  static readonly ApiAgentRemoveAgentDeletePath = '/api/Agent/RemoveAgent';

  /**
   * Removing an agent.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentRemoveAgentDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentRemoveAgentDelete$Response(params?: ApiAgentRemoveAgentDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgentRemoveAgentDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Removing an agent.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentRemoveAgentDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentRemoveAgentDelete(params?: ApiAgentRemoveAgentDelete$Params, context?: HttpContext): Observable<void> {
    return this.apiAgentRemoveAgentDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgentListAgentGet()` */
  static readonly ApiAgentListAgentGetPath = '/api/Agent/ListAgent';

  /**
   * List of agents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListAgentGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListAgentGet$Plain$Response(params?: ApiAgentListAgentGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractAgentInfo>>> {
    return apiAgentListAgentGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * List of agents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListAgentGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListAgentGet$Plain(params?: ApiAgentListAgentGet$Plain$Params, context?: HttpContext): Observable<Array<AgentApiContractAgentInfo>> {
    return this.apiAgentListAgentGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractAgentInfo>>): Array<AgentApiContractAgentInfo> => r.body)
    );
  }

  /**
   * List of agents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListAgentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListAgentGet$Response(params?: ApiAgentListAgentGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractAgentInfo>>> {
    return apiAgentListAgentGet(this.http, this.rootUrl, params, context);
  }

  /**
   * List of agents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListAgentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListAgentGet(params?: ApiAgentListAgentGet$Params, context?: HttpContext): Observable<Array<AgentApiContractAgentInfo>> {
    return this.apiAgentListAgentGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractAgentInfo>>): Array<AgentApiContractAgentInfo> => r.body)
    );
  }

  /** Path part for operation `apiAgentGetAgentDataGet()` */
  static readonly ApiAgentGetAgentDataGetPath = '/api/Agent/GetAgentData';

  /**
   * Agent details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetAgentDataGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetAgentDataGet$Plain$Response(params?: ApiAgentGetAgentDataGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAgentData>> {
    return apiAgentGetAgentDataGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Agent details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetAgentDataGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetAgentDataGet$Plain(params?: ApiAgentGetAgentDataGet$Plain$Params, context?: HttpContext): Observable<AgentApiContractAgentData> {
    return this.apiAgentGetAgentDataGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractAgentData>): AgentApiContractAgentData => r.body)
    );
  }

  /**
   * Agent details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetAgentDataGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetAgentDataGet$Response(params?: ApiAgentGetAgentDataGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAgentData>> {
    return apiAgentGetAgentDataGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Agent details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetAgentDataGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetAgentDataGet(params?: ApiAgentGetAgentDataGet$Params, context?: HttpContext): Observable<AgentApiContractAgentData> {
    return this.apiAgentGetAgentDataGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractAgentData>): AgentApiContractAgentData => r.body)
    );
  }

  /** Path part for operation `apiAgentListIdtypeToaddGet()` */
  static readonly ApiAgentListIdtypeToaddGetPath = '/api/Agent/ListIdtypeToadd';

  /**
   * Getting a list of available card types for an agent (except 998).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListIdtypeToaddGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListIdtypeToaddGet$Plain$Response(params?: ApiAgentListIdtypeToaddGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractIdtypeToadd>>> {
    return apiAgentListIdtypeToaddGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of available card types for an agent (except 998).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListIdtypeToaddGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListIdtypeToaddGet$Plain(params?: ApiAgentListIdtypeToaddGet$Plain$Params, context?: HttpContext): Observable<Array<AgentApiContractIdtypeToadd>> {
    return this.apiAgentListIdtypeToaddGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractIdtypeToadd>>): Array<AgentApiContractIdtypeToadd> => r.body)
    );
  }

  /**
   * Getting a list of available card types for an agent (except 998).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListIdtypeToaddGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListIdtypeToaddGet$Response(params?: ApiAgentListIdtypeToaddGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractIdtypeToadd>>> {
    return apiAgentListIdtypeToaddGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of available card types for an agent (except 998).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListIdtypeToaddGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListIdtypeToaddGet(params?: ApiAgentListIdtypeToaddGet$Params, context?: HttpContext): Observable<Array<AgentApiContractIdtypeToadd>> {
    return this.apiAgentListIdtypeToaddGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractIdtypeToadd>>): Array<AgentApiContractIdtypeToadd> => r.body)
    );
  }

  /** Path part for operation `apiAgentListPtTariffGet()` */
  static readonly ApiAgentListPtTariffGetPath = '/api/Agent/ListPtTariff';

  /**
   * Getting a list of fares intended for paper tickets (QR).
   *
   * An empty list means that paper tickets cannot be sold at the terminal.
   * Can return an error if there is not enough funds on the agent's balance.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListPtTariffGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListPtTariffGet$Plain$Response(params?: ApiAgentListPtTariffGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListPtTariffResponse>>> {
    return apiAgentListPtTariffGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of fares intended for paper tickets (QR).
   *
   * An empty list means that paper tickets cannot be sold at the terminal.
   * Can return an error if there is not enough funds on the agent's balance.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListPtTariffGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListPtTariffGet$Plain(params?: ApiAgentListPtTariffGet$Plain$Params, context?: HttpContext): Observable<Array<AgentApiContractListPtTariffResponse>> {
    return this.apiAgentListPtTariffGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractListPtTariffResponse>>): Array<AgentApiContractListPtTariffResponse> => r.body)
    );
  }

  /**
   * Getting a list of fares intended for paper tickets (QR).
   *
   * An empty list means that paper tickets cannot be sold at the terminal.
   * Can return an error if there is not enough funds on the agent's balance.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListPtTariffGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListPtTariffGet$Response(params?: ApiAgentListPtTariffGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListPtTariffResponse>>> {
    return apiAgentListPtTariffGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of fares intended for paper tickets (QR).
   *
   * An empty list means that paper tickets cannot be sold at the terminal.
   * Can return an error if there is not enough funds on the agent's balance.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListPtTariffGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListPtTariffGet(params?: ApiAgentListPtTariffGet$Params, context?: HttpContext): Observable<Array<AgentApiContractListPtTariffResponse>> {
    return this.apiAgentListPtTariffGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractListPtTariffResponse>>): Array<AgentApiContractListPtTariffResponse> => r.body)
    );
  }

  /** Path part for operation `apiAgentAddPtTicketPost()` */
  static readonly ApiAgentAddPtTicketPostPath = '/api/Agent/AddPtTicket';

  /**
   * Paper ticket data generation (QR) and sale registration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentAddPtTicketPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddPtTicketPost$Plain$Response(params?: ApiAgentAddPtTicketPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractAddPtTicketResponse>>> {
    return apiAgentAddPtTicketPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Paper ticket data generation (QR) and sale registration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentAddPtTicketPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddPtTicketPost$Plain(params?: ApiAgentAddPtTicketPost$Plain$Params, context?: HttpContext): Observable<Array<AgentApiContractAddPtTicketResponse>> {
    return this.apiAgentAddPtTicketPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractAddPtTicketResponse>>): Array<AgentApiContractAddPtTicketResponse> => r.body)
    );
  }

  /**
   * Paper ticket data generation (QR) and sale registration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentAddPtTicketPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddPtTicketPost$Response(params?: ApiAgentAddPtTicketPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractAddPtTicketResponse>>> {
    return apiAgentAddPtTicketPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Paper ticket data generation (QR) and sale registration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentAddPtTicketPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddPtTicketPost(params?: ApiAgentAddPtTicketPost$Params, context?: HttpContext): Observable<Array<AgentApiContractAddPtTicketResponse>> {
    return this.apiAgentAddPtTicketPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractAddPtTicketResponse>>): Array<AgentApiContractAddPtTicketResponse> => r.body)
    );
  }

  /** Path part for operation `apiAgentSetAgentPost()` */
  static readonly ApiAgentSetAgentPostPath = '/api/Agent/SetAgent';

  /**
   * Editing agent data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentSetAgentPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentSetAgentPost$Response(params?: ApiAgentSetAgentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgentSetAgentPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Editing agent data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentSetAgentPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentSetAgentPost(params?: ApiAgentSetAgentPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAgentSetAgentPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgentAddPurchasePost()` */
  static readonly ApiAgentAddPurchasePostPath = '/api/Agent/AddPurchase';

  /**
   * Purchasing a ticket (subscription) on a client card.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentAddPurchasePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddPurchasePost$Plain$Response(params?: ApiAgentAddPurchasePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAddPurchaseResponse>> {
    return apiAgentAddPurchasePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Purchasing a ticket (subscription) on a client card.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentAddPurchasePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddPurchasePost$Plain(params?: ApiAgentAddPurchasePost$Plain$Params, context?: HttpContext): Observable<AgentApiContractAddPurchaseResponse> {
    return this.apiAgentAddPurchasePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractAddPurchaseResponse>): AgentApiContractAddPurchaseResponse => r.body)
    );
  }

  /**
   * Purchasing a ticket (subscription) on a client card.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentAddPurchasePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddPurchasePost$Response(params?: ApiAgentAddPurchasePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAddPurchaseResponse>> {
    return apiAgentAddPurchasePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Purchasing a ticket (subscription) on a client card.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentAddPurchasePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddPurchasePost(params?: ApiAgentAddPurchasePost$Params, context?: HttpContext): Observable<AgentApiContractAddPurchaseResponse> {
    return this.apiAgentAddPurchasePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractAddPurchaseResponse>): AgentApiContractAddPurchaseResponse => r.body)
    );
  }

  /** Path part for operation `apiAgentListTicketTariffGet()` */
  static readonly ApiAgentListTicketTariffGetPath = '/api/Agent/ListTicketTariff';

  /**
   * Getting a list of fares for tickets/subscriptions.
   *
   * Getting a list of fares/tickets available for sale by an agent
   * An empty list means that it is impossible to sell tickets at the terminal.
   * Can return an error if there is not enough funds on the agent's balance.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListTicketTariffGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListTicketTariffGet$Plain$Response(params?: ApiAgentListTicketTariffGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListTicketTariffResponse>>> {
    return apiAgentListTicketTariffGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of fares for tickets/subscriptions.
   *
   * Getting a list of fares/tickets available for sale by an agent
   * An empty list means that it is impossible to sell tickets at the terminal.
   * Can return an error if there is not enough funds on the agent's balance.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListTicketTariffGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListTicketTariffGet$Plain(params?: ApiAgentListTicketTariffGet$Plain$Params, context?: HttpContext): Observable<Array<AgentApiContractListTicketTariffResponse>> {
    return this.apiAgentListTicketTariffGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractListTicketTariffResponse>>): Array<AgentApiContractListTicketTariffResponse> => r.body)
    );
  }

  /**
   * Getting a list of fares for tickets/subscriptions.
   *
   * Getting a list of fares/tickets available for sale by an agent
   * An empty list means that it is impossible to sell tickets at the terminal.
   * Can return an error if there is not enough funds on the agent's balance.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListTicketTariffGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListTicketTariffGet$Response(params?: ApiAgentListTicketTariffGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListTicketTariffResponse>>> {
    return apiAgentListTicketTariffGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of fares for tickets/subscriptions.
   *
   * Getting a list of fares/tickets available for sale by an agent
   * An empty list means that it is impossible to sell tickets at the terminal.
   * Can return an error if there is not enough funds on the agent's balance.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListTicketTariffGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListTicketTariffGet(params?: ApiAgentListTicketTariffGet$Params, context?: HttpContext): Observable<Array<AgentApiContractListTicketTariffResponse>> {
    return this.apiAgentListTicketTariffGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractListTicketTariffResponse>>): Array<AgentApiContractListTicketTariffResponse> => r.body)
    );
  }

  /** Path part for operation `apiAgentCancelPtTicketPost()` */
  static readonly ApiAgentCancelPtTicketPostPath = '/api/Agent/CancelPtTicket';

  /**
   * Cancellation of a printed ticket.
   *
   * Available for printing failure
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentCancelPtTicketPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentCancelPtTicketPost$Plain$Response(params?: ApiAgentCancelPtTicketPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractCancelPtTicketResponse>> {
    return apiAgentCancelPtTicketPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Cancellation of a printed ticket.
   *
   * Available for printing failure
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentCancelPtTicketPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentCancelPtTicketPost$Plain(params?: ApiAgentCancelPtTicketPost$Plain$Params, context?: HttpContext): Observable<AgentApiContractCancelPtTicketResponse> {
    return this.apiAgentCancelPtTicketPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractCancelPtTicketResponse>): AgentApiContractCancelPtTicketResponse => r.body)
    );
  }

  /**
   * Cancellation of a printed ticket.
   *
   * Available for printing failure
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentCancelPtTicketPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentCancelPtTicketPost$Response(params?: ApiAgentCancelPtTicketPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractCancelPtTicketResponse>> {
    return apiAgentCancelPtTicketPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Cancellation of a printed ticket.
   *
   * Available for printing failure
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentCancelPtTicketPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentCancelPtTicketPost(params?: ApiAgentCancelPtTicketPost$Params, context?: HttpContext): Observable<AgentApiContractCancelPtTicketResponse> {
    return this.apiAgentCancelPtTicketPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractCancelPtTicketResponse>): AgentApiContractCancelPtTicketResponse => r.body)
    );
  }

  /** Path part for operation `apiAgentGetPtTicketDataGet()` */
  static readonly ApiAgentGetPtTicketDataGetPath = '/api/Agent/GetPtTicketData';

  /**
   * Getting data about a printed ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetPtTicketDataGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetPtTicketDataGet$Plain$Response(params?: ApiAgentGetPtTicketDataGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractGetPtTicketDataResponse>> {
    return apiAgentGetPtTicketDataGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting data about a printed ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetPtTicketDataGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetPtTicketDataGet$Plain(params?: ApiAgentGetPtTicketDataGet$Plain$Params, context?: HttpContext): Observable<AgentApiContractGetPtTicketDataResponse> {
    return this.apiAgentGetPtTicketDataGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractGetPtTicketDataResponse>): AgentApiContractGetPtTicketDataResponse => r.body)
    );
  }

  /**
   * Getting data about a printed ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetPtTicketDataGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetPtTicketDataGet$Response(params?: ApiAgentGetPtTicketDataGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractGetPtTicketDataResponse>> {
    return apiAgentGetPtTicketDataGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting data about a printed ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetPtTicketDataGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentGetPtTicketDataGet(params?: ApiAgentGetPtTicketDataGet$Params, context?: HttpContext): Observable<AgentApiContractGetPtTicketDataResponse> {
    return this.apiAgentGetPtTicketDataGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractGetPtTicketDataResponse>): AgentApiContractGetPtTicketDataResponse => r.body)
    );
  }

  /** Path part for operation `apiAgentGetClientBalancePost()` */
  static readonly ApiAgentGetClientBalancePostPath = '/api/Agent/GetClientBalance';

  /**
   * Getting the customer's balance.
   *
   * Getting the client's balance. If a phone number is specified, card details are ignored
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetClientBalancePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetClientBalancePost$Plain$Response(params?: ApiAgentGetClientBalancePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractGetClientBalanceResponse>> {
    return apiAgentGetClientBalancePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the customer's balance.
   *
   * Getting the client's balance. If a phone number is specified, card details are ignored
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetClientBalancePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetClientBalancePost$Plain(params?: ApiAgentGetClientBalancePost$Plain$Params, context?: HttpContext): Observable<AgentApiContractGetClientBalanceResponse> {
    return this.apiAgentGetClientBalancePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractGetClientBalanceResponse>): AgentApiContractGetClientBalanceResponse => r.body)
    );
  }

  /**
   * Getting the customer's balance.
   *
   * Getting the client's balance. If a phone number is specified, card details are ignored
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetClientBalancePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetClientBalancePost$Response(params?: ApiAgentGetClientBalancePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractGetClientBalanceResponse>> {
    return apiAgentGetClientBalancePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the customer's balance.
   *
   * Getting the client's balance. If a phone number is specified, card details are ignored
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetClientBalancePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetClientBalancePost(params?: ApiAgentGetClientBalancePost$Params, context?: HttpContext): Observable<AgentApiContractGetClientBalanceResponse> {
    return this.apiAgentGetClientBalancePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractGetClientBalanceResponse>): AgentApiContractGetClientBalanceResponse => r.body)
    );
  }

  /** Path part for operation `apiAgentGetIdInfoPost()` */
  static readonly ApiAgentGetIdInfoPostPath = '/api/Agent/GetIdInfo';

  /**
   * Get ID information.
   *
   * List of tickets and trips for ID.
   * Returns also PAYG trips
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetIdInfoPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetIdInfoPost$Plain$Response(params?: ApiAgentGetIdInfoPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractGetIdInfoResponse>> {
    return apiAgentGetIdInfoPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ID information.
   *
   * List of tickets and trips for ID.
   * Returns also PAYG trips
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetIdInfoPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetIdInfoPost$Plain(params?: ApiAgentGetIdInfoPost$Plain$Params, context?: HttpContext): Observable<AgentApiContractGetIdInfoResponse> {
    return this.apiAgentGetIdInfoPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractGetIdInfoResponse>): AgentApiContractGetIdInfoResponse => r.body)
    );
  }

  /**
   * Get ID information.
   *
   * List of tickets and trips for ID.
   * Returns also PAYG trips
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetIdInfoPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetIdInfoPost$Response(params?: ApiAgentGetIdInfoPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractGetIdInfoResponse>> {
    return apiAgentGetIdInfoPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ID information.
   *
   * List of tickets and trips for ID.
   * Returns also PAYG trips
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetIdInfoPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetIdInfoPost(params?: ApiAgentGetIdInfoPost$Params, context?: HttpContext): Observable<AgentApiContractGetIdInfoResponse> {
    return this.apiAgentGetIdInfoPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractGetIdInfoResponse>): AgentApiContractGetIdInfoResponse => r.body)
    );
  }

  /** Path part for operation `apiAgentAddShiftPost()` */
  static readonly ApiAgentAddShiftPostPath = '/api/Agent/AddShift';

  /**
   * Opening a shift of Agent.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentAddShiftPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddShiftPost$Plain$Response(params?: ApiAgentAddShiftPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAddShiftResponse>> {
    return apiAgentAddShiftPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Opening a shift of Agent.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentAddShiftPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddShiftPost$Plain(params?: ApiAgentAddShiftPost$Plain$Params, context?: HttpContext): Observable<AgentApiContractAddShiftResponse> {
    return this.apiAgentAddShiftPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractAddShiftResponse>): AgentApiContractAddShiftResponse => r.body)
    );
  }

  /**
   * Opening a shift of Agent.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentAddShiftPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddShiftPost$Response(params?: ApiAgentAddShiftPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAddShiftResponse>> {
    return apiAgentAddShiftPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Opening a shift of Agent.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentAddShiftPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddShiftPost(params?: ApiAgentAddShiftPost$Params, context?: HttpContext): Observable<AgentApiContractAddShiftResponse> {
    return this.apiAgentAddShiftPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractAddShiftResponse>): AgentApiContractAddShiftResponse => r.body)
    );
  }

  /** Path part for operation `apiAgentSetShiftClosePost()` */
  static readonly ApiAgentSetShiftClosePostPath = '/api/Agent/SetShiftClose';

  /**
   * Closing the Agent's shift.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentSetShiftClosePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentSetShiftClosePost$Response(params?: ApiAgentSetShiftClosePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgentSetShiftClosePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Closing the Agent's shift.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentSetShiftClosePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentSetShiftClosePost(params?: ApiAgentSetShiftClosePost$Params, context?: HttpContext): Observable<void> {
    return this.apiAgentSetShiftClosePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgentGetClientIdentPost()` */
  static readonly ApiAgentGetClientIdentPostPath = '/api/Agent/GetClientIdent';

  /**
   * obtaining a client identifier (not ID) using the bar code or UID of the card, 
   * depending on the database settings (1 of 2 parameters must be filled: sid or uid).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetClientIdentPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetClientIdentPost$Plain$Response(params?: ApiAgentGetClientIdentPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractClientIdent>> {
    return apiAgentGetClientIdentPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * obtaining a client identifier (not ID) using the bar code or UID of the card, 
   * depending on the database settings (1 of 2 parameters must be filled: sid or uid).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetClientIdentPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetClientIdentPost$Plain(params?: ApiAgentGetClientIdentPost$Plain$Params, context?: HttpContext): Observable<AgentApiContractClientIdent> {
    return this.apiAgentGetClientIdentPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractClientIdent>): AgentApiContractClientIdent => r.body)
    );
  }

  /**
   * obtaining a client identifier (not ID) using the bar code or UID of the card, 
   * depending on the database settings (1 of 2 parameters must be filled: sid or uid).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetClientIdentPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetClientIdentPost$Response(params?: ApiAgentGetClientIdentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractClientIdent>> {
    return apiAgentGetClientIdentPost(this.http, this.rootUrl, params, context);
  }

  /**
   * obtaining a client identifier (not ID) using the bar code or UID of the card, 
   * depending on the database settings (1 of 2 parameters must be filled: sid or uid).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetClientIdentPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetClientIdentPost(params?: ApiAgentGetClientIdentPost$Params, context?: HttpContext): Observable<AgentApiContractClientIdent> {
    return this.apiAgentGetClientIdentPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractClientIdent>): AgentApiContractClientIdent => r.body)
    );
  }

  /** Path part for operation `apiAgentClientIdentificationPost()` */
  static readonly ApiAgentClientIdentificationPostPath = '/api/Agent/ClientIdentification';

  /**
   * Client identification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentClientIdentificationPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentClientIdentificationPost$Plain$Response(params?: ApiAgentClientIdentificationPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractClientIdentificationResponse>> {
    return apiAgentClientIdentificationPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Client identification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentClientIdentificationPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentClientIdentificationPost$Plain(params?: ApiAgentClientIdentificationPost$Plain$Params, context?: HttpContext): Observable<AgentApiContractClientIdentificationResponse> {
    return this.apiAgentClientIdentificationPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractClientIdentificationResponse>): AgentApiContractClientIdentificationResponse => r.body)
    );
  }

  /**
   * Client identification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentClientIdentificationPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentClientIdentificationPost$Response(params?: ApiAgentClientIdentificationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractClientIdentificationResponse>> {
    return apiAgentClientIdentificationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Client identification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentClientIdentificationPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentClientIdentificationPost(params?: ApiAgentClientIdentificationPost$Params, context?: HttpContext): Observable<AgentApiContractClientIdentificationResponse> {
    return this.apiAgentClientIdentificationPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractClientIdentificationResponse>): AgentApiContractClientIdentificationResponse => r.body)
    );
  }

  /** Path part for operation `apiAgentListTrmOrgGet()` */
  static readonly ApiAgentListTrmOrgGetPath = '/api/Agent/ListTrmOrg';

  /**
   * Getting a list of transport administrations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListTrmOrgGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListTrmOrgGet$Plain$Response(params?: ApiAgentListTrmOrgGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListTrmOrgResponse>>> {
    return apiAgentListTrmOrgGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of transport administrations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListTrmOrgGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListTrmOrgGet$Plain(params?: ApiAgentListTrmOrgGet$Plain$Params, context?: HttpContext): Observable<Array<AgentApiContractListTrmOrgResponse>> {
    return this.apiAgentListTrmOrgGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractListTrmOrgResponse>>): Array<AgentApiContractListTrmOrgResponse> => r.body)
    );
  }

  /**
   * Getting a list of transport administrations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListTrmOrgGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListTrmOrgGet$Response(params?: ApiAgentListTrmOrgGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListTrmOrgResponse>>> {
    return apiAgentListTrmOrgGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of transport administrations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListTrmOrgGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListTrmOrgGet(params?: ApiAgentListTrmOrgGet$Params, context?: HttpContext): Observable<Array<AgentApiContractListTrmOrgResponse>> {
    return this.apiAgentListTrmOrgGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractListTrmOrgResponse>>): Array<AgentApiContractListTrmOrgResponse> => r.body)
    );
  }

  /** Path part for operation `apiAgentListServiceTicketsPost()` */
  static readonly ApiAgentListServiceTicketsPostPath = '/api/Agent/ListServiceTickets';

  /**
   * Getting a list of service tickets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListServiceTicketsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentListServiceTicketsPost$Plain$Response(params?: ApiAgentListServiceTicketsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListServiceTicketsResponse>>> {
    return apiAgentListServiceTicketsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of service tickets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListServiceTicketsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentListServiceTicketsPost$Plain(params?: ApiAgentListServiceTicketsPost$Plain$Params, context?: HttpContext): Observable<Array<AgentApiContractListServiceTicketsResponse>> {
    return this.apiAgentListServiceTicketsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractListServiceTicketsResponse>>): Array<AgentApiContractListServiceTicketsResponse> => r.body)
    );
  }

  /**
   * Getting a list of service tickets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListServiceTicketsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentListServiceTicketsPost$Response(params?: ApiAgentListServiceTicketsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListServiceTicketsResponse>>> {
    return apiAgentListServiceTicketsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of service tickets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListServiceTicketsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentListServiceTicketsPost(params?: ApiAgentListServiceTicketsPost$Params, context?: HttpContext): Observable<Array<AgentApiContractListServiceTicketsResponse>> {
    return this.apiAgentListServiceTicketsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractListServiceTicketsResponse>>): Array<AgentApiContractListServiceTicketsResponse> => r.body)
    );
  }

  /** Path part for operation `apiAgentListAvailTicketsPost()` */
  static readonly ApiAgentListAvailTicketsPostPath = '/api/Agent/ListAvailTickets';

  /**
   * Getting a list of available tariffs (tickets to buy).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListAvailTicketsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentListAvailTicketsPost$Plain$Response(params?: ApiAgentListAvailTicketsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListAvailTicketsResponse>>> {
    return apiAgentListAvailTicketsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of available tariffs (tickets to buy).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListAvailTicketsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentListAvailTicketsPost$Plain(params?: ApiAgentListAvailTicketsPost$Plain$Params, context?: HttpContext): Observable<Array<AgentApiContractListAvailTicketsResponse>> {
    return this.apiAgentListAvailTicketsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractListAvailTicketsResponse>>): Array<AgentApiContractListAvailTicketsResponse> => r.body)
    );
  }

  /**
   * Getting a list of available tariffs (tickets to buy).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListAvailTicketsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentListAvailTicketsPost$Response(params?: ApiAgentListAvailTicketsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListAvailTicketsResponse>>> {
    return apiAgentListAvailTicketsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of available tariffs (tickets to buy).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListAvailTicketsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentListAvailTicketsPost(params?: ApiAgentListAvailTicketsPost$Params, context?: HttpContext): Observable<Array<AgentApiContractListAvailTicketsResponse>> {
    return this.apiAgentListAvailTicketsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractListAvailTicketsResponse>>): Array<AgentApiContractListAvailTicketsResponse> => r.body)
    );
  }

  /** Path part for operation `apiAgentListIdtypeXGet()` */
  static readonly ApiAgentListIdtypeXGetPath = '/api/Agent/ListIdtypeX';

  /**
   * Getting a list of available media.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListIdtypeXGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListIdtypeXGet$Plain$Response(params?: ApiAgentListIdtypeXGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListIdtypeXResponse>>> {
    return apiAgentListIdtypeXGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of available media.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListIdtypeXGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListIdtypeXGet$Plain(params?: ApiAgentListIdtypeXGet$Plain$Params, context?: HttpContext): Observable<Array<AgentApiContractListIdtypeXResponse>> {
    return this.apiAgentListIdtypeXGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractListIdtypeXResponse>>): Array<AgentApiContractListIdtypeXResponse> => r.body)
    );
  }

  /**
   * Getting a list of available media.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListIdtypeXGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListIdtypeXGet$Response(params?: ApiAgentListIdtypeXGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListIdtypeXResponse>>> {
    return apiAgentListIdtypeXGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of available media.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListIdtypeXGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListIdtypeXGet(params?: ApiAgentListIdtypeXGet$Params, context?: HttpContext): Observable<Array<AgentApiContractListIdtypeXResponse>> {
    return this.apiAgentListIdtypeXGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractListIdtypeXResponse>>): Array<AgentApiContractListIdtypeXResponse> => r.body)
    );
  }

  /** Path part for operation `apiAgentCheckIdIsdoublePost()` */
  static readonly ApiAgentCheckIdIsdoublePostPath = '/api/Agent/CheckIdIsdouble';

  /**
   * card availability check.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentCheckIdIsdoublePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentCheckIdIsdoublePost$Response(params?: ApiAgentCheckIdIsdoublePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgentCheckIdIsdoublePost(this.http, this.rootUrl, params, context);
  }

  /**
   * card availability check.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentCheckIdIsdoublePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentCheckIdIsdoublePost(params?: ApiAgentCheckIdIsdoublePost$Params, context?: HttpContext): Observable<void> {
    return this.apiAgentCheckIdIsdoublePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgentGetShiftReportPost()` */
  static readonly ApiAgentGetShiftReportPostPath = '/api/Agent/GetShiftReport';

  /**
   * shift report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetShiftReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetShiftReportPost$Plain$Response(params?: ApiAgentGetShiftReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractGetShiftReportResponse>> {
    return apiAgentGetShiftReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * shift report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetShiftReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetShiftReportPost$Plain(params?: ApiAgentGetShiftReportPost$Plain$Params, context?: HttpContext): Observable<AgentApiContractGetShiftReportResponse> {
    return this.apiAgentGetShiftReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractGetShiftReportResponse>): AgentApiContractGetShiftReportResponse => r.body)
    );
  }

  /**
   * shift report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentGetShiftReportPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetShiftReportPost$Response(params?: ApiAgentGetShiftReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractGetShiftReportResponse>> {
    return apiAgentGetShiftReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * shift report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentGetShiftReportPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentGetShiftReportPost(params?: ApiAgentGetShiftReportPost$Params, context?: HttpContext): Observable<AgentApiContractGetShiftReportResponse> {
    return this.apiAgentGetShiftReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentApiContractGetShiftReportResponse>): AgentApiContractGetShiftReportResponse => r.body)
    );
  }

}
